import SBO from "assets/images/game/e-sports/vs-sbo.png";
import { SubGameType } from "types/game";

export const listGameEsports: SubGameType[] = [
  {
    game_code: "0",
    name: "Lobby",
    provider_code: "SBO",
    type: "VS",
    featured: "NO",
    new_arrive: "NO",
    picture: SBO
  }
];
